import { PromptData } from '../types';

export function generatePrompt(data: PromptData): string {
  // Special template for image generation
  if (data.format === 'Image generation') {
    return `I want you to act as an image generation expert. Create a detailed prompt for generating an image about ${data.topic}.

Target Audience: ${data.audience}
Style/Tone: ${data.tone}
Complexity: ${data.complexity}
Industry Context: ${data.industry}

Please provide a comprehensive image generation prompt that:
1. Is highly detailed and specific
2. Includes style descriptors (e.g., photorealistic, artistic, 3D rendered)
3. Describes lighting, perspective, and composition
4. Specifies any relevant color schemes
5. Mentions desired mood and atmosphere
6. Includes technical specifications if relevant
7. Considers the industry context of ${data.industry}
8. Is optimized for ${data.audience}

Goal: ${data.goal}

Format the prompt in a way that's optimized for image generation AI models.`;
  }

  // Original template for text-based formats
  return `You are an expert AI assistant specializing in ${data.industry}. I need your help to ${data.goal} about ${data.topic}.

Target Audience: ${data.audience}
Tone of Voice: ${data.tone}
Complexity Level: ${data.complexity}
Output Format: ${data.format}

Please provide a comprehensive response that:
1. Is specifically tailored for ${data.audience}
2. Maintains a ${data.tone.toLowerCase()} tone throughout
3. Matches a ${data.complexity.toLowerCase()} level of understanding
4. Follows a ${data.format.toLowerCase()} structure
5. Incorporates industry-specific best practices for ${data.industry}
6. Includes practical examples and actionable steps
7. Considers current trends and standards
8. Focuses on measurable outcomes

Format your response in a clear, structured manner that optimizes readability and implementation.`;
}